import React from "react";
import colors from "../../utils/colors";
import { whyUseImage } from "../../assets";
import { secondImage } from "../../assets";
import Button from "../../components/ui/button";
import { useNavigate } from "react-router-dom";

const WhySection = () => {
  const navigate = useNavigate();
  const items = [
    {
      title: "Appointment management",
      desc: "Schedule, view and manage appointments with patients within a few seconds",
    },
    {
      title: "Health record management",
      desc: "Access and update patients medical records seamlessly.",
    },
    {
      title: "Less paperwork",
      desc: "No need to store stacks of medical records anymore. Everything can be managed here.",
    },
    {
      title: "Interesting Consultation!",
      desc: "Added features that make consultation session more interesting.",
    },
  ];
  return (
    <div
      className="px-4 sm:px-8 md:px-16 lg:px-[8.5rem] py-10 sm:py-16 md:py-20 lg:py-[6.25rem]"
      style={{ background: colors.lightGrey }}
    >
      <div className="flex flex-col gap-12 sm:gap-16 md:gap-20 items-start">
        <div
          style={{ color: colors.dark }}
          className="font-lexend text-2xl sm:text-3xl md:text-4xl lg:text-[2.5rem] font-semibold md:leading-[3.5rem] lg:leading-[4.375rem] tracking-[0.025rem]"
        >{`Why you should always use Ubimed Medical Consultation app`}</div>
        <div className="flex flex-col lg:flex-row justify-between items-start w-full gap-12 lg:gap-8">
          <div className="flex flex-1 flex-col gap-12 sm:gap-16 md:gap-20 items-start w-full lg:w-auto">
            {items.map((item, ind) => (
              <div
                key={ind}
                className="flex flex-col sm:flex-row gap-4 sm:gap-6 md:gap-[2.5rem] items-start sm:items-center"
              >
                <div
                  style={{ color: "white", background: colors.primary }}
                  className="rounded-md sm:rounded-[0.5rem] h-16 w-16 sm:h-20 sm:w-20 lg:h-[5.625rem] lg:w-[5.625rem] p-2 sm:p-[0.625rem] lg:px-[1.25rem] flex justify-center items-center font-lexend text-xl sm:text-2xl md:text-3xl lg:text-[2.5rem] font-semibold md:leading-[3.5rem] lg:leading-[4.375rem] tracking-[0.025rem]"
                >{`0${ind + 1}`}</div>

                <div className="flex flex-col gap-2 sm:gap-3 md:gap-[1.25rem]">
                  <div
                    className="font-lexend text-lg sm:text-xl md:text-[1.5rem] font-semibold tracking-[0.015rem]"
                    style={{ color: colors.dark }}
                  >
                    {item.title}
                  </div>
                  <div className="font-lato text-sm sm:text-base lg:text-[1.125rem] font-normal leading-normal sm:leading-relaxed lg:leading-[1.5rem] tracking-[0.1125rem]">
                    {item.desc}
                  </div>
                </div>
              </div>
            ))}
          </div>
          <img
            src={secondImage}
            className="w-full max-w-md mx-auto lg:max-w-none lg:w-[40.6rem] rounded-lg"
          />
        </div>
        <Button
          text="Join us"
          theme="primary"
          className="w-full sm:w-auto px-6 sm:px-[2rem] py-3 sm:py-[1rem] rounded-md sm:rounded-[0.5rem] text-sm sm:text-base"
          onClick={() => navigate("/signup")}
        />
      </div>
    </div>
  );
};

export default WhySection;
